import { GroupInterface } from "../Groups/Group.Interface";
import { LocationInterface } from "../Locations/Location.Interface";
import { OrgInterface } from "../Org/Org.Interface";
import { LocationVarKey } from "./Generated/LocationVarKey.Data";

export interface LocationVarInterface {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  orgId: number;
  org: OrgInterface;
  key: string;
  value: string;
  /**
   * Raw operator-authored prose for Cortex policy vars. See LocationVariable.Entity.ts.
   * Excluded from default finds — consumers must explicitly select when needed.
   */
  source?: string | null;
  groupId?: number;
  group?: GroupInterface;
  locationId?: number;
  location?: LocationInterface;
}

export enum LocationVarInheritance {
  NONE = "none",
  GROUP = "group",
  ORG = "org",
  DEFAULT = "default"
}
export interface LocationVarWithId {
  id: number;
  key: string;
  value: string;
  source?: string | null;
}
export interface MergedLocationVar {
  id?: number;
  key: string;
  value: string;
  source?: string | null;
  inheritance: LocationVarInheritance;
}
export type MergedLocationVars = { [key in LocationVarKey]?: MergedLocationVar };
export type MergedVarsWithKeys<T extends LocationVarKey> = { [key in T]: MergedLocationVar };
export type LocationVarsById = { [id in number]?: LocationVarInterface };
export type LocationVarsWithIdByKey = { [key in LocationVarKey]?: LocationVarWithId };
export type LocationVarsWithIdByKeyByGroupOrLocationId = { [groupOrLocationId: number]: { [key in LocationVarKey]?: LocationVarWithId } };

export enum LimitToLocationType {
  GROUP = "group",
  LOCATION = "location",
  ORG = "org"
}

export const PostProcessLocationVars = [LocationVarKey.Name, LocationVarKey.CortexFacilityName];
